import React, { FC, useState, useEffect } from "react";
import {
  FormControl,
  MenuItem,
  Select,
  SelectChangeEvent,
  FormHelperText,
  Grid,
  InputLabel,
  Tooltip,
  Box,
  Checkbox,
  ListItemText,
  Chip,
} from "@mui/material";
import { FormFieldProps } from "../../../utils/formFields";
import useStyles from "../../../components/common/model/styles";

const FormMultiSelectCheckboxField: FC<FormFieldProps> = (props) => {
  const classes = useStyles();
  const [selectedValues, setSelectedValues] = useState<string[]>(
    props?.selectedValues || props?.value || []
  );

  console.log("FormMultiSelectCheckboxField props:", props);

  useEffect(() => {
    if (props.selectedValues) {
      setSelectedValues(props.selectedValues);
    } else if (props.value) {
      setSelectedValues(Array.isArray(props.value) ? props.value : []);
    } else {
      setSelectedValues([]);
    }
  }, [props.selectedValues, props.value]);

  const handleChange = (event: SelectChangeEvent<string[]>) => {
    const value = event.target.value;
    const newValue = typeof value === "string" ? value.split(",") : value;
    setSelectedValues(newValue);

    if (props.onChange) {
      props.onChange({
        target: {
          id: event?.target?.name,
          value: newValue,
        },
      });
    }
  };

  let boolVar = props?.options
    ? props?.options.some((value) => {
        return typeof value == "object";
      })
    : false;

  const getOptionLabel = (option: any) => {
    return (
      option?.name ||
      option?.label ||
      option?.type_name ||
      option?.role ||
      option
    );
  };

  const getOptionValue = (option: any) => {
    return boolVar ? option?.id : option;
  };

  const renderValue = (selected: string[]) => {
    if (selected.length === 0) {
      return (
        <span style={{ color: "#999" }}>
          {props?.placeHolder ? props?.placeHolder : "Select"}
        </span>
      );
    }

    return (
      <Box sx={{ display: "flex", flexWrap: "wrap", gap: 0.5 }}>
        {selected.map((value) => {
          const option = props.options?.find((opt: any) => {
            const optValue = getOptionValue(opt);
            return optValue === value;
          });
          const label = option ? getOptionLabel(option) : value;
          return (
            <Chip
              key={value}
              label={label}
              size="small"
              sx={{ textTransform: "capitalize" }}
            />
          );
        })}
      </Box>
    );
  };

  const selectRender = () => (
    <FormControl
      variant="outlined"
      style={{
        marginTop: props?.isNonMarginTop ? "0px" : "",
        width: props?.width ? props?.width : "",
        display: props?.display,
      }}
      fullWidth
      sx={{
        mt: 2,
        mb: 1,
        "& .MuiOutlinedInput-root": {
          border: props.error ? "none" : "1px solid #c4c4c4",
        },
        "& .MuiOutlinedInput-notchedOutline": {
          border: "none",
        },
        minHeight: "36px",
        borderRadius: "5px",
        border: props.error ? "1px solid #d32f2f" : "none",
      }}
      error={Boolean(props.error)}
      size="small"
    >
      <Select
        disabled={props.disabled || false}
        sx={{
          background: "#fff",
          minHeight: props?.heightVal ? props?.heightVal : "36px",
          "& .MuiSelect-select": {
            minHeight: props?.heightVal ? props?.heightVal : "36px !important",
            padding: "6px 14px",
            display: "flex",
            alignItems: "center",
          },
        }}
        multiple
        displayEmpty
        value={selectedValues}
        onChange={handleChange}
        name={props.id}
        renderValue={renderValue}
        MenuProps={{
          PaperProps: {
            style: {
              maxHeight: 300,
            },
          },
        }}
      >
        <MenuItem value="" disabled>
          <em>{props?.placeHolder ? props?.placeHolder : "Select"}</em>
        </MenuItem>
        {props.options &&
          props.options.map((option: any, index: number) => {
            const optionValue = getOptionValue(option);
            const optionLabel = getOptionLabel(option);
            const isSelected = selectedValues.indexOf(optionValue) > -1;

            return (
              <MenuItem
                key={index}
                value={optionValue}
                sx={{ textTransform: "capitalize",padding:'0px' }}
                title={option?.tooltip || ""}
              >
                <Checkbox checked={isSelected} />
                <ListItemText primary={optionLabel} />
              </MenuItem>
            );
          })}
      </Select>
      {props.error && <FormHelperText>{props.helperText}</FormHelperText>}
    </FormControl>
  );

  return (
    <>
      {props.label && !props.inSingleGridForm ? (
        <>
          <Grid
            item
            xs={12}
            sm={props?.md ? (props?.firstColmd ? props?.firstColmd : 1.5) : 5}
            className={classes.labelBox}
            sx={{ marginTop: props?.isNonMarginTop ? "0px !important" : "" }}
          >
            <Tooltip title={props?.tooltipText || ""} arrow>
              <InputLabel
                sx={{ color: "#333333", fontWeight: 600, fontSize: "18px" }}
                shrink
                htmlFor={props.id}
              >
                {props.label}
                {props.isRequired && (
                  <span style={{ color: "red", fontWeight: 500 }}>*</span>
                )}
              </InputLabel>
            </Tooltip>
          </Grid>
          <Grid
            item
            xs={12}
            sm={props?.md ? props?.md : 7}
            style={{ padding: "0px" }}
          >
            {selectRender()}
          </Grid>
        </>
      ) : props.label && props.inSingleGridForm ? (
        <Grid
          item
          xs={12}
          sm={props?.md ? props?.md : 12}
          sx={{
            display: "block",
            alignItems: "center",
            gap: 2,
            ...props?.GridFieldStyle,
          }}
        >
          <Tooltip title={props?.tooltipText || ""} arrow>
            <InputLabel
              sx={{
                color: "#637381",
                fontWeight: 600,
                fontSize: "16px",
                textAlign: "left",
              }}
              shrink
              htmlFor={props.id}
            >
              {props.label}
              {props.isRequired && (
                <span style={{ color: "red", fontWeight: 500 }}>*</span>
              )}
            </InputLabel>
          </Tooltip>
          {selectRender()}
        </Grid>
      ) : (
        selectRender()
      )}
    </>
  );
};

export default FormMultiSelectCheckboxField;
